export const AGREEMENT_CREATED = "AGREEMENT_CREATED";
export const AGREEMENT_ACTION_REQUESTED = "AGREEMENT_ACTION_REQUESTED";
export const AGREEMENT_EMAIL_VIEWED = "AGREEMENT_EMAIL_VIEWED";
export const AGREEMENT_DOCUMENTS_VIEWED = "AGREEMENT_DOCUMENTS_VIEWED";
export const AGREEMENT_ACTION_COMPLETED = "AGREEMENT_ACTION_COMPLETED";
export const AGREEMENT_WORKFLOW_COMPLETED = "AGREEMENT_WORKFLOW_COMPLETED";
export const EMAIL = "Email";
export const SIGNER = "Signer";
export const COMMENT = "Comment";
